module.exports = __webpack_public_path__ + "img/weather_snow.8d2052fa.png";